module.exports = __webpack_public_path__ + "static/media/Bag_blue.24a3e326.svg";